/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();

(function () {
  "use strict";

  const canHover = window.matchMedia("(hover: hover) and (pointer: fine)");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

  function warmHoverVideo(video) {
    if (
      !video ||
      !canHover.matches ||
      reduceMotion.matches ||
      (connection && connection.saveData) ||
      video.dataset.hoverVideoWarmed === "true"
    ) {
      return;
    }

    video.dataset.hoverVideoWarmed = "true";
    video.preload = "auto";
    video.load();
  }

  function scheduleHoverVideoWarmup(video) {
    if (video.dataset.hoverVideoWarmScheduled === "true") return;
    video.dataset.hoverVideoWarmScheduled = "true";

    const warmup = function () {
      video.dataset.hoverVideoWarmScheduled = "false";
      warmHoverVideo(video);
    };

    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(warmup, { timeout: 800 });
    } else {
      window.setTimeout(warmup, 150);
    }
  }

  const hoverVideoObserver =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          function (entries, observer) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              const video = entry.target;
              scheduleHoverVideoWarmup(video);
              observer.unobserve(video);
            });
          },
          { rootMargin: "400px 0px" }
        )
      : null;

  const heroVideoObserver =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              const wrapper = entry.target;
              const video = wrapper.querySelector("video");
              if (!video) return;

              if (entry.isIntersecting) {
                if (reduceMotion.matches) {
                  video.preload = "metadata";
                  video.load();
                  return;
                }

                video.preload = "auto";
                if (wrapper.dataset.videoHeroAutoplay === "true") {
                  const playPromise = video.play();
                  if (playPromise && typeof playPromise.catch === "function") {
                    playPromise.catch(function () {});
                  }
                }
              } else {
                video.pause();
              }
            });
          },
          { rootMargin: "100px 0px" }
        )
      : null;

  function registerHoverVideos(root) {
    const videos = [];

    if (root instanceof Element && root.matches("[data-product-hover-video] video")) {
      videos.push(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll("[data-product-hover-video] video").forEach(function (video) {
        videos.push(video);
      });
    }

    videos.forEach(function (video) {
      if (video.dataset.hoverVideoObserved === "true") return;
      video.dataset.hoverVideoObserved = "true";
      if (hoverVideoObserver) {
        hoverVideoObserver.observe(video);
      }
    });
  }

  function registerHeroVideos(root) {
    const wrappers = [];

    if (root instanceof Element && root.matches("[data-video-hero-autoplay]")) {
      wrappers.push(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll("[data-video-hero-autoplay]").forEach(function (wrapper) {
        wrappers.push(wrapper);
      });
    }

    wrappers.forEach(function (wrapper) {
      if (wrapper.dataset.heroVideoObserved === "true") return;
      wrapper.dataset.heroVideoObserved = "true";
      if (heroVideoObserver) {
        heroVideoObserver.observe(wrapper);
      }
    });
  }

  function registerMedia(root) {
    registerHoverVideos(root);
    registerHeroVideos(root);
  }

  function getVideoWrap(target) {
    if (!(target instanceof Element)) return null;
    return target.closest(".grid-product__image-wrap");
  }

  function startHoverVideo(wrap) {
    if (!wrap || !canHover.matches || reduceMotion.matches) return;

    const video = wrap.querySelector("[data-product-hover-video] video");
    if (!video) return;

    warmHoverVideo(video);

    wrap.dataset.hoverVideoRequested = "true";
    const playPromise = video.play();

    if (playPromise && typeof playPromise.then === "function") {
      playPromise
        .then(function () {
          if (wrap.dataset.hoverVideoRequested === "true") {
            wrap.classList.add("is-hover-video-active");
          }
        })
        .catch(function () {
          wrap.classList.remove("is-hover-video-active");
        });
    } else {
      wrap.classList.add("is-hover-video-active");
    }
  }

  function stopHoverVideo(wrap) {
    if (!wrap) return;

    wrap.dataset.hoverVideoRequested = "false";
    wrap.classList.remove("is-hover-video-active");

    const video = wrap.querySelector("[data-product-hover-video] video");
    if (!video) return;

    video.pause();
    try {
      video.currentTime = 0;
    } catch (error) {}
  }

  document.addEventListener("mouseover", function (event) {
    const wrap = getVideoWrap(event.target);
    if (!wrap || (event.relatedTarget && wrap.contains(event.relatedTarget))) return;
    startHoverVideo(wrap);
  });

  document.addEventListener("mouseout", function (event) {
    const wrap = getVideoWrap(event.target);
    if (!wrap || (event.relatedTarget && wrap.contains(event.relatedTarget))) return;
    stopHoverVideo(wrap);
  });

  function initializeMedia() {
    registerMedia(document);

    const mediaMutationObserver = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node instanceof Element) {
            registerMedia(node);
          }
        });
      });
    });

    mediaMutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeMedia);
  } else {
    initializeMedia();
  }
})();
